import React, { Component } from "react"

import {
    css,
    Button,
    Icon,
    Spinner,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import trans from 'trans'

import {Project, ShapeSet, ShapeSetFile} from "app/types/model-types";
import { BADGE_TYPE } from "shape-entities/types/shape";
import { find } from "lodash";

import {
    updateInputValue as change,
    selectFormValues,
} from "app/reducers/form";
import { getFormName } from "./helpers";
import { connect } from "react-redux";
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers";
import { ReduxList } from "app/types/app-types";
import { getLangPrefixFromOutputFormat } from "trans/helpers";
import { iconDisabledColor } from "template-edit/components/tools-panel";
import SetFilesSelect from "shape-edit/components/set-files-select";

interface Props {
    shapeIndex: string
    project: Project
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    change: typeof change
    shapeSets: ReduxList<ShapeSet[]>
}

interface State {

}

class BadgeForm extends Component<Props, State> {
    protected handleOnLoadDebounced
    protected canvasRef: Element

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { shapeSets, form, shapeIndex, isAlt, project } = this.props
        const shape = form.shapes[shapeIndex]
        const formName = getFormName(isAlt)

        if (!shape || !shapeSets || !shapeSets.data) {
            return <Spinner />
        }

        const outputLangPrefix = getLangPrefixFromOutputFormat(project.output_format)

        const currentSet = shape.set_id ? find(shapeSets.data, (set: ShapeSet) => {
            return set.id === shape.set_id
        }) : null

        const currentFile = currentSet ? find(currentSet.files, (file: ShapeSetFile) => {
            return file.id === shape.set_file_id
        }) : null

        return (
            <React.Fragment>
                <StyledNavigationGrid>
                    <GridCell style={{ cursor: 'pointer' }} onClick={() => {
                        this.props.change(formName, `shapes.${shape.index}`, {
                            ...shape,
                            type: BADGE_TYPE,
                            set_id: null,
                            set_file_id: null,
                            imageBlob: null,
                            set: null,
                            external_image_prompt: null,
                        })
                    }}>{trans('badges')}
                    </GridCell>
                    {currentSet &&
                        <GridCell> › {trans(currentSet.name)}</GridCell>
                    }
                    {currentFile &&
                        <GridCell> › {currentFile.filename}</GridCell>
                    }
                </StyledNavigationGrid>

                <div className={'set-fields'}>
                    <SetFilesSelect
                        outputLangPrefix={outputLangPrefix}
                        shapeIndex={shapeIndex}
                    />
                </div>
            </React.Fragment>
        )
    }
}


const StyledNavigationGrid = css(Grid)({
    marginTop: '40px',
    marginBottom: '20px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(40px, max-content))',
    gridAutoFlow: 'row !important',
    gridGap: '10px',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
        color: iconDisabledColor,
    },
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        shapeSets: state.shapeSets,
        project: state.project,
    }
}

export default connect(mapStateToProps, {
    change,
})(BadgeForm)
